import classnames from 'clsx';
import React from 'react';

import styles from '../shared.scss';
import type { NormalizedWallPosts } from '../utils/normalizeWallPosts';

import type { ReplyProps } from './WallPost';
import WallPost from './WallPost';

interface Props {
  loading: boolean;
  isManager: boolean;
  isRightSide?: boolean;
  posts: NormalizedWallPosts[];
  onReply?: ({ post, parentId }: ReplyProps) => void;
  onDeleteWallPost?: (id: number) => void;
}

const Wall: React.FC<Props> = ({
  loading,
  onReply,
  isManager,
  isRightSide,
  onDeleteWallPost,
  posts
}) => (
  <div className={classnames(styles.postsContainer, { [styles.rightSide]: isRightSide })}>
    {posts &&
      posts.map((p) => (
        <WallPost
          key={p.id}
          post={p}
          loading={loading}
          handleReply={onReply}
          handleDeleteWallPost={onDeleteWallPost}
          canManage={isManager}
          isRightSide={isRightSide}
        />
      ))}
  </div>
);

export default Wall;
